import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';
import Home from '../views/Home.vue'
import Loading from '../views/Loading.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },  
  {
    path: '/interest',
    name: 'Interested In',    
    component: () => import(/* webpackChunkName: "interested" */ '../views/InterestedIn.vue')
  },
  {
    path: '/games-attending',
    name: 'Games Attending',    
    component: () => import(/* webpackChunkName: "attending" */ '../views/Attending.vue'),
    props : {type:'gameOptions', text:'### would you like to attend games?', highlightedText:'how often'}
  },
  {
    path: '/groups-attending',
    name: 'Groups Attending',    
    component: () => import(/* webpackChunkName: "attending" */ '../views/Attending.vue'),
    props : {type:'groupGuestOptions', text:'### guests do you think will be part of your group?', highlightedText:'how many'}
  },
  {
    path: '/guests-attending',
    name: 'Guests Attending',    
    component: () => import(/* webpackChunkName: "attending" */ '../views/Attending.vue'),
    props : {type:'guestOptions', text:'### guests would you typically attend with?', highlightedText:'how many'}
  },
  {
    path: '/my-options',
    name: 'My Options',    
    component: () => import(/* webpackChunkName: "attending" */ '../views/Attending.vue'),
    props : {type:'corporateOptions', text:'### you like to entertain clients or reward staff?', highlightedText:'how would'}
  },
  {
    path: '/benefits',
    name: 'Ideal Benefits',    
    component: () => import(/* webpackChunkName: "benefits" */ '../views/IdealBenefits.vue'),
    beforeEnter: (to, from) => {
      if(store.state.benefitRecommendations.length == 0) {
        router.push({ name: 'Home' });
      }
      return true;
    },
  },
  {
    path: '/recommendation',
    name: 'Recommendation',    
    component: () => import(/* webpackChunkName: "recommendation" */ '../views/Recommendation.vue'),
    beforeEnter: (to, from) => {
      const selectedBenefits = store.state.benefitRecommendations.filter(element => element.selected);
      to.previousRoute = from.name
      if(selectedBenefits.length == 0) {
        router.push({ name: 'Home' });
      }
      return true;
    },
  },
  {
    path: '/dev',
    name: 'Dev',    
    component: () => import(/* webpackChunkName: "recommendation" */ '../views/Dev.vue'),
  },
  {
    path: '/visualize',
    name: 'Visualize Benefits',    
    component: () => import(/* webpackChunkName: "recommendation" */ '../views/Visualize.vue'),
  },
  {
    path: '/plans-dev',
    name: 'Visualize Plans',    
    component: () => import(/* webpackChunkName: "recommendation" */ '../views/Visualize.vue'),
  },
  {
    path: '/plans-recommendation/:plan',
    name: 'Visualize Recommendation',    
    component: () => import(/* webpackChunkName: "recommendation" */ '../views/TestRecommendation.vue'),
  },
  { path: "/:pathMatch(.*)*", component: Loading }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})
router.afterEach((to, from, next) => {
  document.title = to.name === 'Home' ? 'Ticket Finder' : to.name ?? 'Ticket Finder';
});

export default router
